module.exports = __webpack_public_path__ + "img/ammiraglio 3.2fb4fb78.jpeg";